import calculateWaterAvailable from './getWaterAvailable';
import getLookupValues from './getLookupValues';
import getScenarioName from './getScenarioName';

export default function runScenario1(language, values) {
  const lookupValues = getLookupValues(
    values.crops,
    values.weatherStation,
    values.soilCode,
    values.landAvailableUnit,
    language
  );

  let landAvailable = parseFloat(values.landAvailable);
  let waterAvailable = calculateWaterAvailable(values);

  // calculate total water needs
  let totalCropWaterNeeds = 0;
  values.crops.forEach((crop, cropIndex) => {
    const cropYield = crop.typicalYield;
    const cropProfit = crop.marketPrice * cropYield - crop.costToPlant;

    const monthlyWater = lookupValues[crop.name].monthlyWater * 1000; // convert from m3 to liters

    values.crops[cropIndex]['profit'] = cropProfit;
    values.crops[cropIndex]['waterNeeds'] = monthlyWater;

    totalCropWaterNeeds += monthlyWater;
  });

  // determine area to award each crop
  let area1 = waterAvailable / totalCropWaterNeeds;
  let area2 = landAvailable / values.crops.length;
  const area = area1 < area2 ? area1 : area2;

  let cropMix = [];
  let profits = [];
  let waterUse = [];
  let irrigationRequiredTime = [];

  values.crops.forEach((crop) => {
    cropMix.push([
      {
        x: getScenarioName(1, language),
        y: area,
        name: crop.name,
      },
    ]);
    profits.push([
      {
        x: getScenarioName(1, language),
        y: (area * crop.profit) / 1000,
        name: crop.name,
      },
    ]);
    waterUse.push([
      {
        x: getScenarioName(1, language),
        y: Math.round((area * crop.waterNeeds) / 1000),
        name: crop.name,
      },
    ]);
    irrigationRequiredTime.push([
      {
        x: getScenarioName(1, language),
        y:
          (area * crop.waterNeeds) /
          (parseFloat(values.waterAccessFlowRate) * 3600),
        name: crop.name,
      },
    ]);
  });

  return { cropMix, profits, waterUse, irrigationRequiredTime };
}
